import { render, staticRenderFns } from "./SupplierBoxInfo.vue?vue&type=template&id=6b94ae08&scoped=true&"
import script from "./SupplierBoxInfo.vue?vue&type=script&lang=js&"
export * from "./SupplierBoxInfo.vue?vue&type=script&lang=js&"
import style0 from "./SupplierBoxInfo.vue?vue&type=style&index=0&id=6b94ae08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94ae08",
  null
  
)

export default component.exports